import React from "react";
import { Button } from 'primereact/button';

const ProFormFooter = ({onCancel, onSave, danger=false, enableOnDirty=true})=>{
    return <div className="p-d-flex p-jc-start" style={{marginTop: "25px"}}>
        <Button label="Cancel" type="button" className="p-button-text" onClick={onCancel} style={{color:"#34436d"}} />
        {!danger && <Button label="Save" type='submit' disabled={!enableOnDirty} hidden={true}  onClick={onSave} style={{backgroundColor: "#34436d"}} />}
        {danger && <Button className="p-button-danger" label="Remove" type='submit' hidden={true}  onClick={onSave} />} 
    </div>

}

export default ProFormFooter;